import useI18n from "@i18n";
import { Typography } from "@mui/material";
import { HeroContent } from "@Components/game/activity/styled-components";

const ActivityHero = () => {
  const { i18n } = useI18n();

  return (
    <HeroContent>
      <Typography variant="text7xl800" color="dsBase.v200">
        {i18n("activity.hero.title")}
      </Typography>
      <Typography variant="text1xl400" color="dsBase.v200" width="50%">
        {i18n("activity.hero.subtitle")}
      </Typography>
    </HeroContent>
  );
};

export default ActivityHero;
